import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { NgbDropdownModule, NgbProgressbarModule, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import moment from 'moment';

@Component({
  selector: 'app-zing-hrreport',
  standalone: true,
  imports: [CommonModule, RouterModule, DataTablesModule, NgbProgressbarModule, FormsModule, NgbDropdownModule, NgSelectModule, NgbDatepickerModule],
  providers: [DatePipe,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './zing-hrreport.component.html',
  styleUrl: './zing-hrreport.component.scss'
})
export class ZingHRReportComponent {
  isDisabled: boolean = false;
  EmployeeData = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};

  Filter = {
    SelectType: 'RE',
    EmpCode: null,
    FromDate: null as any,
    ToDate: null as any,
    MonthYearObj: null as any,
    Status: 'ALL'
  }

  constructor(
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private toast: ToastService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
    this.dtoptions.ordering = false;
    this.dtoptions.columnDefs = [
      {
        targets: 0,
        width: '300px',
      },
    ];
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  onNavigate(event: any) {
    this.Filter.MonthYearObj = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.ESS_EmpZingHrSync_APIReport();
    }
    else {
      form.submitted = true;
    }
  }

  ESS_EmpZingHrSync_APIReport() {
    this.isDisabled = true;

    this.Filter.FromDate = this.dateFormat.format(this.Filter.MonthYearObj);
    this.Filter.ToDate = structuredClone(this.Filter.MonthYearObj);
    this.Filter.ToDate.day = new Date(this.Filter.ToDate.year, this.Filter.ToDate.month, 0).getDate();
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDate);


    this.employeeRegistration.ESS_EmpZingHrSync_APIReport(this.Filter).subscribe({
      next: (response) => {
        this.EmployeeData = Object.values(response.map((response: any) => ({ ...response, expanded: this.common.ToLowerCase(response.Status) != 'success' })));
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          const TodayDate = moment(response.Table[0].RegistrationDate)
          this.Filter.MonthYearObj = {
            "year": TodayDate.year(),
            "month": TodayDate.month() + 1,
            "day": 1
          };
        }
        this.ESS_EmpZingHrSync_APIReport();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  toggleRow(i: number): void {
    this.EmployeeData[i].expanded = !this.EmployeeData[i].expanded;
  }

  ExportExcel() {
    if (this.EmployeeData.length > 0) {
      this.common.ExcelDump('ZingHRReport', this.EmployeeData);
    } else {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    }
  }

  clear() {
    this.EmployeeData = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }
}
